import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listSummaries, issueCommendation } from '../lib/db.js';
import { useAuth } from '../lib/auth.jsx';
import { StatusBar } from '../components/StatusBar.jsx';
import { BottomNav } from '../components/BottomNav.jsx';

const CATS = [
  { k: 'performance', label: 'ผลงานดีเด่น', icon: '★' },
  { k: 'service', label: 'บริการลูกค้า', icon: '♥' },
  { k: 'teamwork', label: 'ช่วยทีม', icon: '⊕' },
  { k: 'other', label: 'อื่นๆ', icon: '＋' },
];
const POINTS = [0, 10, 20, 50];
const today = () => new Date().toISOString().slice(0, 10);

export function Recognize() {
  const { appUser } = useAuth();
  const [emps, setEmps] = useState([]);
  const [empId, setEmpId] = useState('');
  const [category, setCategory] = useState('performance');
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');
  const [points, setPoints] = useState(10);
  const [date, setDate] = useState(today());
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null); // { empName, empId, rec }
  const [err, setErr] = useState('');

  useEffect(() => {
    listSummaries()
      .then((rows) => {
        setEmps(rows);
        if (rows[0]) setEmpId(rows[0].id);
      })
      .catch((e) => setErr(e.message));
  }, []);

  const selected = emps.find((e) => e.id === empId);
  const empName = selected ? (selected.nickname || `${selected.first_name} ${selected.last_name}`) : '';
  const catLabel = CATS.find((c) => c.k === category)?.label ?? '';

  async function onIssue() {
    if (!empId || !title.trim()) { setErr('เลือกพนักงาน + กรอกหัวข้อก่อน'); return; }
    setErr('');
    setBusy(true);
    try {
      const rec = await issueCommendation({
        employee_id: empId, category, title: title.trim(), detail: detail.trim(),
        reward_points: points, occurred_on: date, issued_by: appUser?.id,
      });
      setResult({ empName, empId, rec });
      setTitle(''); setDetail(''); setPoints(10);
    } catch (e) {
      setErr(e.message);
    }
    setBusy(false);
  }

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <div className="title-row">
          <div>
            <div className="eyebrow">หัวหน้า/แอดมินเป็นผู้บันทึก</div>
            <h1 className="page">ชมเชย</h1>
          </div>
          <span className="glyph">★</span>
        </div>

        {result && (
          <div className="ok-banner">
            <div className="l1">✓ ออกใบชมเชยให้ {result.empName} แล้ว</div>
            <div className="note">
              {result.rec.reward_points > 0 ? `+${result.rec.reward_points} แต้มรางวัล · ` : ''}
              บันทึก audit เรียบร้อย · <Link to={`/employees/${result.empId}`}>ดูในโปรไฟล์</Link>
            </div>
          </div>
        )}

        <label className="f">พนักงาน</label>
        <select value={empId} onChange={(e) => setEmpId(e.target.value)}>
          {emps.map((e) => (
            <option key={e.id} value={e.id}>
              {(e.nickname || e.first_name)} · {e.position} · {e.branch}
            </option>
          ))}
        </select>

        <label className="f">ประเภท</label>
        <div className="seg">
          {CATS.map((c) => (
            <button key={c.k} aria-pressed={category === c.k} onClick={() => setCategory(c.k)}>
              <span>{c.icon}</span>{c.label}
            </button>
          ))}
        </div>

        <label className="f">หัวข้อ</label>
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}
          placeholder="เช่น ปิดการขายลูกค้ารายใหญ่" />

        <label className="f">รายละเอียด</label>
        <textarea value={detail} onChange={(e) => setDetail(e.target.value)}
          placeholder="อธิบายสิ่งที่ทำได้ดี เพื่อบันทึกไว้เป็นหลักฐานเชิงบวก…" />

        <label className="f">แต้มรางวัล (ไม่บังคับ)</label>
        <div className="seg pts">
          {POINTS.map((p) => (
            <button key={p} aria-pressed={points === p} onClick={() => setPoints(p)}>
              {p === 0 ? 'ไม่ให้' : `+${p}`}
            </button>
          ))}
        </div>

        <label className="f">วันที่</label>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />

        {(title.trim() || detail.trim()) && (
          <div className="card">
            <div className="eyebrow" style={{ marginBottom: 6 }}>ตัวอย่างใบชมเชย</div>
            <div className="l1" style={{ fontSize: 16, fontWeight: 700 }}>ใบชมเชย — {catLabel}</div>
            <div className="note" style={{ marginTop: 8 }}>
              ขอชมเชย คุณ {empName || '—'} ในเรื่อง “{title.trim() || '…'}”
              {detail.trim() ? ` — ${detail.trim()}` : ''} บริษัทขอบันทึกผลงานนี้ไว้เป็นเกียรติ
              {points > 0 ? ` พร้อมมอบ ${points} แต้มรางวัล` : ''}.
            </div>
          </div>
        )}

        {err && <p className="err" style={{ marginTop: 14 }}>{err}</p>}

        <button className="cta" onClick={onIssue} disabled={busy}>
          {busy ? 'กำลังบันทึก…' : 'ออกใบชมเชย · บันทึกผลงาน'}
        </button>
        <p className="note" style={{ marginTop: 14, textAlign: 'center' }}>
          บันทึกด้านบวกคู่กับด้านลบ เพื่อความเป็นธรรมในการประเมิน
        </p>
      </section>
      <BottomNav />
    </div>
  );
}
